export const LEANPUB_URL = 'https://leanpub.com/testing-angular-jest';
export const AMAZON_URL = 'https://www.amazon.es/dp/B0FF9P23ZZ';
export const UDEMY_URL = 'https://bit.ly/angular-moderno';

export const SOCIAL_LINKS = {
  twitter: 'https://twitter.com/domini_code',
  github: 'https://github.com/domini-code',
  youtube: 'https://youtube.com/dominicode',
  facebook: 'https://facebook.com/dominicodee',
  instagram: 'https://instagram.com/domini_code',
  linkedin: 'https://www.linkedin.com/in/dominicode',
  tiktok: 'https://tiktok.com/@domini_code',
  twitch: 'https://twitch.tv/domini_code',
  discord: 'https://discord.com/domini_code',
  telegram: 'https://t.me/domini_code',
};
